import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

import {Constants} from '../../shared/config/constants.config';
import {QuoteViewModel} from '../viewModels/quote.viewModel';
import {FAQViewModel} from '../../faq/viewModels/faq.viewModel';
import {TermViewModel} from '../viewModels/term.viewModel';

@Injectable()
export class WebsiteService {
    constructor(private readonly httpClient: HttpClient, private readonly constants: Constants) {
    }

    getQuote(): Observable<QuoteViewModel> {
        return this.httpClient.get<QuoteViewModel>(`${this.constants.apiURL()}/website/quote/`);
    }

    getFAQ(): Observable<FAQViewModel[]> {
        return this.httpClient.get<FAQViewModel[]>(`${this.constants.apiURL()}/dashboard/faq/`);
    }

    getTermsAndConditions(): Observable<TermViewModel> {
        return this.httpClient.get<TermViewModel>(`${this.constants.apiURL()}/website/term/`);
    }
}
